import type { Plugin } from '@capacitor/core';
import { registerPlugin } from '@capacitor/core';

interface WifiConnectOptions {
  ssid: string;
  passphrase: string;
  hidden?: boolean;
}

export interface WifiInfo {
  ssid: string | null;
  ipAddress: string | null;
  gateway: string | null;
}

export interface WifiInfoDidChangeEvent {
  wifi: WifiInfo | null;
}

export enum WifiExtensionEvent {
  WIFI_INFO_DID_CHANGE = 'wifiInfoDidChange',
}

export interface WifiExtensionPlugin extends Plugin {
  connect(options: WifiConnectOptions): Promise<void>;
  disconnect(): Promise<void>;
  getWifiInfo(): Promise<WifiInfo>;
}

const WifiExtension = registerPlugin<WifiExtensionPlugin>(
  'WifiExtensionPlugin'
);

export { WifiExtension };
